/**
 * Created by zed on 2021/9/19
 * Copyright © 2017 www.moemone.com. All rights reserved.
 *
 * 【数据模拟】
 * 不需要拦截接口返回模拟数据时，请注释掉相关代码（不导入）
 */

/* ===== 动态加载 Mock 数据 ===== */
const mockModule = process.env.VUE_APP_MOCK_MODULE

if (mockModule) {
  try {
    require(`./modules/${mockModule}`)
    console.log(`[Mock] Loaded module: ${mockModule}`)
  } catch (e) {
    console.error(`[Mock] Failed to load module: ${mockModule}`, e)
  }
} else {
  console.warn('[Mock] No VUE_APP_MOCK_MODULE environment variable defined.')
}
